import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  container: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px"
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0
  }
}));

export default styles;
